import { ApplicationForm } from './ApplicationForm'
import { Box } from '@mui/material'
import { Navbar } from '../../../components/Navbar'
import { Footer } from '../../../components/Footer'
import { PageContainer } from '../../../components/styled/PageContainer'
import { Helmet } from 'react-helmet'

export const TNGCampaignForm = () => {
  return (
    <Box>
      <Helmet>
        <title>Nexen Tire X Tng Campaign</title>
      </Helmet>
      <Navbar />
      <PageContainer>
        <Box display='flex' justifyContent='center'>
          <img src={'/client-static/tngCampaign/NexenTnG.png'} width='100%' />
        </Box>
        <ApplicationForm />
      </PageContainer>
      <Footer />
    </Box>
  )
}
